import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const MailChimpListField = ({ value, onSelect, switchField, canCreate, mailChimpLists }) => {
    const options = useMemo(
        () =>
            (mailChimpLists || []).map((item) => ({
                label: item.name,
                value: item.id,
            })),
        [mailChimpLists],
    );

    const actions = useMemo(() => {
        if (!canCreate) return undefined;
        return [
            {
                isLink: true,
                label: getLiteral('action_mailchimp_new_list'),
                onClick: switchField,
            },
        ];
    }, [canCreate, switchField]);

    const selectValue = useMemo(() => {
        if (!value?.id) return null;
        return { label: value.text, value: value.id };
    }, [value]);

    const handleChange = useCallback(
        (option) => {
            if (!option) {
                onSelect(null);
                return;
            }
            onSelect({ text: option.label, id: option.value });
        },
        [onSelect],
    );

    return (
        <div className="fm-mailchimp-list">
            <Select
                actions={actions}
                className="fm-mailchimp-list__select"
                isClearable
                isFullWidth
                isSearchable
                label={getLiteral('label_mailchimp_export_choose_list')}
                labelMode="horizontal"
                onChange={handleChange}
                options={options}
                placeholder={getLiteral('label_selectone')}
                value={selectValue}
            />
        </div>
    );
};

MailChimpListField.propTypes = {
    canCreate: PropTypes.bool,
    mailChimpLists: PropTypes.array,
    onSelect: PropTypes.func,
    switchField: PropTypes.func,
    value: PropTypes.object,
};

export default memo(MailChimpListField);
